var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQcIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5001 17L18.5001 22L15.0001 18.5L16.5001 17L18.5001 19L22.0001 15.5L23.5001 17ZM12.0001 9C12.7958 9 13.5588 9.31607 14.1214 9.87868C14.6841 10.4413 15.0001 11.2044 15.0001 12C15.0001 12.7956 14.6841 13.5587 14.1214 14.1213C13.5588 14.6839 12.7958 15 12.0001 15C11.2045 15 10.4414 14.6839 9.8788 14.1213C9.31619 13.5587 9.00012 12.7956 9.00012 12C9.00012 11.2044 9.31619 10.4413 9.8788 9.87868C10.4414 9.31607 11.2045 9 12.0001 9ZM12.0001 4.5C17.0001 4.5 21.2701 7.61 23.0001 12C22.7501 12.65 22.4401 13.26 22.0801 13.85C21.5001 13.5 20.8601 13.25 20.1801 13.12L20.8201 12C19.1701 8.64 15.7601 6.5 12.0001 6.5C8.24012 6.5 4.83012 8.64 3.18012 12C4.83012 15.36 8.24012 17.5 12.0001 17.5L13.2101 17.43C13.0701 17.93 13.0001 18.46 13.0001 19V19.46L12.0001 19.5C7.00012 19.5 2.73012 16.39 1.00012 12C2.73012 7.61 7.00012 4.5 12.0001 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQcIcon);
export default __webpack_public_path__ + "static/media/qcIcon.ea499b64d38dcfb0a0b13b76d1d7c1f3.svg";
export { ForwardRef as ReactComponent };